import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    loading,
    message
}) {

    // const toggle = () => setModal(!modal);

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            {message || 'Are you sure you want to delete?'}
                        </h3>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" onClick={onConfirm} disabled={loading}>{loading ? 'Please wait...' : 'Yes'}</button>
                    <button className="table_delete" onClick={onClose} disabled={loading}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationModal;